export default {
    computed: {
      isSuperAdmin () {
          return window.NodesRoles.indexOf('Super Admin') !== -1
      }
    },
    methods: {
        $can(permissionName) {
            if (this.isSuperAdmin) {
                return true
            }
            return window.NodesPermissions.indexOf(permissionName) !== -1;
        },
    },
}
